var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEntryuserappicon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Entry_user_app_icon",
    "data-name": "Entry user app icon",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 55.418,
    height: 97.799,
    viewBox: "0 0 55.418 97.799",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_4228",
    "data-name": "Rectangle 4228",
    width: 55.418,
    height: 97.799,
    fill: "#56aa1c"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_11512",
    "data-name": "Group 11512",
    transform: "translate(0 0)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_36695",
    "data-name": "Path 36695",
    d: "M50.9,0H4.522A4.527,4.527,0,0,0,0,4.522V93.277A4.527,4.527,0,0,0,4.522,97.8H50.9a4.527,4.527,0,0,0,4.522-4.523V4.522A4.527,4.527,0,0,0,50.9,0M17.315,5.113A1.718,1.718,0,0,1,19.031,3.4H38.154A1.718,1.718,0,0,1,39.87,5.113v.131A1.718,1.718,0,0,1,38.154,6.96H19.031a1.718,1.718,0,0,1-1.716-1.716ZM28.593,92.472a4.036,4.036,0,1,1,4.037-4.036,4.041,4.041,0,0,1-4.037,4.036m23.888-12.29a2.371,2.371,0,0,1-2.369,2.369H7.073A2.371,2.371,0,0,1,4.7,80.182V11.987A2.372,2.372,0,0,1,7.073,9.618H50.112a2.372,2.372,0,0,1,2.369,2.369Z",
    transform: "translate(0 0)",
    fill: "#56aa1c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_36696",
    "data-name": "Path 36696",
    d: "M39.572,45.935c-.316,1.9-1.371,2.636-3.848,3.848s-9.769.637-17.235-6.8c-7.436-7.467-8.01-14.765-6.8-17.236s1.95-3.531,3.847-3.848c1.4-.233,2.08-.723,2.721-.081a3.8,3.8,0,0,1,.7,1.188,48.88,48.88,0,0,0,2.532,4.849s1.054,1.16-.633,2.319a8.813,8.813,0,0,0-2.16,1.845c-.475.475-.743.749.21,2.741a16.287,16.287,0,0,0,2.866,4.246c.08.079.162.158.244.234l.212.212c.076.082.153.162.233.242a16.278,16.278,0,0,0,4.248,2.867c1.991.954,2.266.686,2.741.211A8.851,8.851,0,0,0,31.3,40.611c1.159-1.687,2.32-.631,2.32-.631a48.672,48.672,0,0,0,4.849,2.529,3.815,3.815,0,0,1,1.188.7c.642.642.152,1.325-.081,2.722",
    transform: "translate(3.01 6.541)",
    fill: "#56aa1c"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEntryuserappicon);
export default __webpack_public_path__ + "static/media/Entry user app icon.c9a769d8697569747274a1d8a6eb8c88.svg";
export { ForwardRef as ReactComponent };